// @flow

import { defineMessages } from 'react-intl'

// Constants
import {
  MSG_SEASON_LABEL,
  MSG_FORM_HEADING,
  MSG_FORM_HINT_MESSAGE,
  MSG_ERROR_FILE_REQUIRED,
  MSG_ERROR_EXTRA_FILES,
  MSG_ERROR_WRONG_EXTENSION,
  MSG_ERROR_MISSING_SEASON,
  MSG_WARNING_WRONG_EXTENSION,
  MSG_WARNING_UNKNOWN,
  MSG_POPUP_HEADING,
  MSG_JOB_IMPORT_FAILED,
  MSG_JOBS_IMPORT_FAILED,
  MSG_SUCCESSFUL_IMPORT,
  MSG_PARTIALLY_SUCCESSFUL_IMPORT,
  MSG_OK_BUTTON,
  MSG_SUBMIT_BTN,
  MSG_CANCEL_BTN,
} from './constants'

export default defineMessages({
  [MSG_FORM_HEADING]: {
    id: 'importJobsTool.formHeading',
    defaultMessage: 'Import soil tests exported from the old account',
  },
  [MSG_FORM_HINT_MESSAGE]: {
    id: 'importJobsTool.hintMessage',
    defaultMessage: 'Please ensure all required farms and fields have been created prior to importing ' +
    'previous soil sample results.',
  },
  [MSG_SEASON_LABEL]: {
    id: 'importJobsTool.seasonLabel',
    defaultMessage: 'Season',
  },
  [MSG_ERROR_FILE_REQUIRED]: {
    id: 'importJobsTool.filesRequiredError',
    defaultMessage: 'No file found, please select a .zip file.',
  },
  [MSG_ERROR_EXTRA_FILES]: {
    id: 'importJobsTool.extraFilesError',
    defaultMessage: 'Select a single .zip file per season.',
  },
  [MSG_ERROR_WRONG_EXTENSION]: {
    id: 'importJobsTool.wrongExtensionError',
    defaultMessage: 'Please select .zip file.',
  },
  [MSG_ERROR_MISSING_SEASON]: {
    id: 'importJobsTool.missingSeasonError',
    defaultMessage: 'Season is a required field',
  },
  [MSG_WARNING_WRONG_EXTENSION]: {
    id: 'importJobsTool.wrongExtensionWarning',
    defaultMessage: ' has a wrong extension. Only .zip file is accepted',
  },
  [MSG_WARNING_UNKNOWN]: {
    id: 'importJobsTool.unknownFileWarning',
    defaultMessage: 'Selected file can not be used.',
  },
  [MSG_SUBMIT_BTN]: {
    id: 'importJobsTool.submitButton',
    defaultMessage: 'Submit',
  },
  [MSG_CANCEL_BTN]: {
    id: 'importJobsTool.cancelButton',
    defaultMessage: 'Cancel',
  },
  [MSG_POPUP_HEADING]: {
    id: 'importJobsPopup.popupHeader',
    defaultMessage: 'Import result',
  },
  [MSG_JOB_IMPORT_FAILED]: {
    id: 'importJobsPopup.jobImportFailed',
    defaultMessage: 'The following job failed to import:',
  },
  [MSG_JOBS_IMPORT_FAILED]: {
    id: 'importJobsPopup.jobsImportFailed',
    defaultMessage: 'The following jobs failed to import:',
  },
  [MSG_SUCCESSFUL_IMPORT]: {
    id: 'importJobsPopup.successfulImport',
    defaultMessage: 'All jobs imported successfully',
  },
  [MSG_PARTIALLY_SUCCESSFUL_IMPORT]: {
    id: 'importJobsPopup.partiallySuccessfulImport',
    defaultMessage: 'All other jobs imported successfully.',
  },
  [MSG_OK_BUTTON]: {
    id: 'importJobsPopup.okButton',
    defaultMessage: 'Ok',
  },
})
